import { globalBuildContext } from 'rlink-router/__globalBuildContextForLegacySupport__';
import pushToNavState from 'rlink-router/actions/pushToNavState';
import { HASH } from 'rlink-router/constants';

export default function setHash (hash, force) {
  let track = force || window.hashTrack;
  if (track
      && hash !== location.hash
      && window.history
      && window.history.pushState) {
    let { dispatch } = globalBuildContext.reduxStore;
    dispatch(pushToNavState(globalBuildContext, {view: 'home', params: {[HASH]: hash}}));
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/setHash.js